<template>
  <transition name="animate-notification">
    <button
      v-if="telegramEnabled"
      class="btn btn-middle tg-notification-button"
      type="button"
      @click="navigate"
    >
      Перейти в телеграм-бот
      <Telegram class="tg-notification-button__icon" />
    </button>
  </transition>
</template>

<script>
import Telegram from "@/assets/icons/telegram.svg";
import { getNotificationTgBotLink } from "../../application/requests/notificationsRequests";

export default {
  name: "TgNotificationButton",

  props: {
    telegramEnabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      required: true,
    },
    tabId: {
      type: Number,
      default: null,
    },
  },

  components: {
    Telegram,
  },

  data() {
    return {
      link: "",
    };
  },

  methods: {
    navigate() {
      if (!this.link) {
        return;
      }

      this.$emit("telegram-bot-opened", true);

      window.open(this.link, "_blank", "noopener,noreferrer");
    },
  },

  async created() {
    if (this.mode === "Create") {
      this.$emit("telegram-bot-opened", true);
    } else {
      const res = await getNotificationTgBotLink(this.tabId);
      this.link = res.data.link;
      this.$emit("telegram-bot-opened", res.data.active);
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

.tg-notification-button {
  display: flex;
  gap: 10px;
  &__icon {
    width: 19px;
  }
}
</style>
